import { createSlice } from "@reduxjs/toolkit"
import { AllowedEntityNames } from "features/entity-caching/constants"
import { createFire, deleteFire, getOneProject, initializeFires, updateFire } from "./thunks"
import { ProjectExtended } from "@nova/schemas"
import { arrToMap } from "nodash"

const initialState = {
    byId: {} as Record<string, ProjectExtended | undefined>,
    backgroundUpdating: "",
    needsSnapshotUpdate: undefined as number | undefined,
}

export const slice = createSlice({
    name: AllowedEntityNames.Fires,
    initialState,
    reducers: {
        addViewerToProject: (state, { payload }) => {
            const viewers = state.byId[payload.id]?.viewers
            if (!viewers) return
            if (!viewers.find((e) => e.id === payload.user.id))
                viewers.push({ ...payload.user, projectId: payload.id })
        },
        removeViewerFromProject: (state, action) => {
            const viewers = state.byId[action.payload.id]?.viewers
            if (!viewers) return
            const userIdx = viewers.findIndex((e) => e.id === action.payload.user.id)
            if (userIdx !== -1) viewers.splice(userIdx, 1)
        },
        addDroneToProject: (state, { payload }) => {
            const drones = state.byId[payload.id]?.drones
            if (!drones) return
            if (!drones.find((d) => d.flightId === payload.drone.flightId))
                drones.push(payload.drone)
        },
        removeDroneFromProject: (state, action) => {
            const drones = state.byId[action.payload.id]?.drones
            if (!drones) return
            const droneIdx = drones.findIndex((d) => d.flightId === action.payload.flightId)
            if (droneIdx !== -1) drones.splice(droneIdx, 1)
        },
        setProjectBackgroundUpdating: (state, action) => {
            const projectId = action.payload
            state.backgroundUpdating = projectId
        },
        setProjectBackgroundFinishedUpdating: (state, action) => {
            const projectId = action.payload
            if (state.backgroundUpdating === projectId) {
                state.backgroundUpdating = ""
            }
        },
        setProjectLocationLocally: (
            state,
            action: {
                payload: { projectId: string; location: { latitude: number; longitude: number } }
            }
        ) => {
            const project = state.byId[action.payload.projectId]
            if (project) project.location = action.payload.location
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(initializeFires.fulfilled, (state, action) => {
                const items = action.payload
                state.byId = arrToMap(items, "id")
            })
            .addCase(getOneProject.fulfilled, (state, action) => {
                const item = action.payload
                state.byId[item.id] = item
            })
            .addCase(createFire.fulfilled, (state, action) => {
                const item = action.payload
                state.byId[item.id] = item
            })
            .addCase(deleteFire.fulfilled, (state, action) => {
                const { id } = action.payload
                delete state.byId[id]
            })
            .addCase(updateFire.fulfilled, (state, action) => {
                const currentFire = state.byId[action.meta.arg.id]!
                state.byId[action.meta.arg.id] = {
                    ...currentFire,
                    ...action.meta.arg.updates,
                }
            })

        return builder
    },
})

export const { actions, reducer } = slice
export const {
    addViewerToProject,
    removeViewerFromProject,
    addDroneToProject,
    removeDroneFromProject,
    setProjectBackgroundUpdating,
    setProjectBackgroundFinishedUpdating,
    setProjectLocationLocally,
} = actions

export default reducer
